"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateList = exports.listSchemaJoiSchema = exports.listJoiSchema = exports.LIST_SCOPE = exports.PLACE_LEGEND = exports.TASK_TYPE = exports.LIST_TYPE = exports.LIST_ACCESS_RIGHT_FOR_WEB_USER = exports.LIST_ACCESS_RIGHT_FOR_MOBILE_USER = exports.LIST_ATTRIBUTE_TYPE = void 0;
const joi = __importStar(require("joi"));
const tools_1 = require("../tools");
const workflows_1 = require("./workflows");
/**
 * Type of attributes in the schema of the list
 */
var LIST_ATTRIBUTE_TYPE;
(function (LIST_ATTRIBUTE_TYPE) {
    LIST_ATTRIBUTE_TYPE["INTEGER"] = "INTEGER";
    LIST_ATTRIBUTE_TYPE["DECIMAL"] = "DECIMAL";
    LIST_ATTRIBUTE_TYPE["TEXT"] = "TEXT";
    LIST_ATTRIBUTE_TYPE["BOOLEAN"] = "BOOLEAN";
    LIST_ATTRIBUTE_TYPE["DATE"] = "DATE";
    LIST_ATTRIBUTE_TYPE["SIGNATURE"] = "SIGNATURE";
    LIST_ATTRIBUTE_TYPE["PICTURE"] = "PICTURE";
    LIST_ATTRIBUTE_TYPE["GPS"] = "GPS";
    LIST_ATTRIBUTE_TYPE["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    LIST_ATTRIBUTE_TYPE["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    LIST_ATTRIBUTE_TYPE["PHONE_NUMBER"] = "PHONE_NUMBER";
    LIST_ATTRIBUTE_TYPE["BARCODE_SCANNER"] = "BARCODE_SCANNER";
    LIST_ATTRIBUTE_TYPE["SINGLE_CHOICE_ON_LIST"] = "SINGLE_CHOICE_ON_LIST";
})(LIST_ATTRIBUTE_TYPE = exports.LIST_ATTRIBUTE_TYPE || (exports.LIST_ATTRIBUTE_TYPE = {}));
/**
 * List Access Right for App user
 */
var LIST_ACCESS_RIGHT_FOR_MOBILE_USER;
(function (LIST_ACCESS_RIGHT_FOR_MOBILE_USER) {
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["READ_ONLY"] = "READ_ONLY";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["FULL_ACCESS"] = "FULL_ACCESS";
    LIST_ACCESS_RIGHT_FOR_MOBILE_USER["HIDDEN"] = "HIDDEN";
})(LIST_ACCESS_RIGHT_FOR_MOBILE_USER = exports.LIST_ACCESS_RIGHT_FOR_MOBILE_USER || (exports.LIST_ACCESS_RIGHT_FOR_MOBILE_USER = {}));
/**
 * List Access Right for Web user
 */
var LIST_ACCESS_RIGHT_FOR_WEB_USER;
(function (LIST_ACCESS_RIGHT_FOR_WEB_USER) {
    LIST_ACCESS_RIGHT_FOR_WEB_USER["NO_ACCESS"] = "NO_ACCESS";
    LIST_ACCESS_RIGHT_FOR_WEB_USER["READ_ONLY"] = "READ_ONLY";
    LIST_ACCESS_RIGHT_FOR_WEB_USER["FULL_ACCESS"] = "FULL_ACCESS";
})(LIST_ACCESS_RIGHT_FOR_WEB_USER = exports.LIST_ACCESS_RIGHT_FOR_WEB_USER || (exports.LIST_ACCESS_RIGHT_FOR_WEB_USER = {}));
/**
 * List Type
 */
var LIST_TYPE;
(function (LIST_TYPE) {
    LIST_TYPE["GENERIC"] = "GENERIC";
    LIST_TYPE["SKU"] = "SKU";
    LIST_TYPE["PLACE"] = "PLACE";
    LIST_TYPE["NPLET"] = "NPLET";
    LIST_TYPE["TASK"] = "TASK";
})(LIST_TYPE = exports.LIST_TYPE || (exports.LIST_TYPE = {}));
/**
 * Type of task
 */
var TASK_TYPE;
(function (TASK_TYPE) {
    TASK_TYPE["WORKFLOW_BASED"] = "WORKFLOW_BASED";
    TASK_TYPE["SIMPLE"] = "SIMPLE";
})(TASK_TYPE = exports.TASK_TYPE || (exports.TASK_TYPE = {}));
/**
 * Place Legend
 */
var PLACE_LEGEND;
(function (PLACE_LEGEND) {
    PLACE_LEGEND["TYPE"] = "type";
    PLACE_LEGEND["USER"] = "user";
    PLACE_LEGEND["LAST_VISIT"] = "last_visit";
})(PLACE_LEGEND = exports.PLACE_LEGEND || (exports.PLACE_LEGEND = {}));
/**
 * List Scope
 */
var LIST_SCOPE;
(function (LIST_SCOPE) {
    LIST_SCOPE["GLOBAL"] = "GLOBAL";
    LIST_SCOPE["TEAM"] = "TEAM";
    LIST_SCOPE["SINGLE_TEAM"] = "SINGLE_TEAM";
    LIST_SCOPE["MOBILE_USER"] = "MOBILE_USER";
    LIST_SCOPE["SINGLE_MOBILE_USER"] = "SINGLE_MOBILE_USER";
})(LIST_SCOPE = exports.LIST_SCOPE || (exports.LIST_SCOPE = {}));
exports.listJoiSchema = joi.object().keys({
    id: joi.string(),
    name: joi.string().required(),
    description: joi.string(),
    list_type: joi.string().valid(...Object.values(LIST_TYPE)),
    scope: joi.string().valid(...Object.values(LIST_SCOPE)),
    can_update_items_ownership: joi.boolean(),
    mobile_access_right: joi
        .string()
        .valid(...Object.values(LIST_ACCESS_RIGHT_FOR_MOBILE_USER)),
    web_access_right: joi
        .string()
        .valid(...Object.values(LIST_ACCESS_RIGHT_FOR_WEB_USER)),
    schema: joi.any().required(),
    client_id: joi.string(),
    created_at: joi.any(),
    updated_at: joi.any(),
    actif: joi.bool(),
    important: joi.array().items(joi.string()),
    filtrable: joi.array().items(joi.string()),
    task_meta: joi.object().keys({
        scope_question_text: joi.string(),
        due_date_offset: joi.number().required(),
        expiration_date_offset: joi.number().required(),
        priority_level: joi.number().required(),
        owner_question_tag: joi.string(),
        scope_value_tag: joi.string(),
        type: joi
            .string()
            .valid(...[TASK_TYPE.SIMPLE, TASK_TYPE.WORKFLOW_BASED])
            .required(),
        descriptive_text: joi.object().keys({
            question_tag: joi.string(),
            title_prefix: joi.string(),
            attributes: joi.array().items(joi.string()),
        }),
        descriptive_text_template: joi.string(),
        descriptive_text_template_on_done: joi.string(),
        scope: joi.string(),
        tags_generator_to_task: joi
            .array()
            .items(joi.object().keys({
            matrix_binding: joi.array().items(joi.object().keys({
                matrix_wf_task_tag: joi.string().required(),
                matrix_wf_generator_tag: joi.string().required(),
            })),
            wf_generator_tag: joi.string().required(),
            wf_task_tag: joi.string().required(),
            generator_attribute: joi.string(),
            task_attribute: joi.string(),
        }))
            .required(),
    }),
    title_in_card: joi.string(),
    select_team_label: joi.string(),
    key_attribute_category: joi.string(),
    picture_in_card: joi.string(),
    version: joi.number(),
    conditions: joi.array().items(joi.object().keys({
        id: joi.number().required(),
        priority: joi.number().required(),
        first: joi.object().keys({
            type: joi.string().required(),
            value: joi.string(),
            tag: joi.string(),
            param: joi.string(),
            condition_id: joi.number(),
        }),
        second: joi.object().keys({
            type: joi.string().required(),
            value: joi.string(),
            tag: joi.string(),
            param: joi.string(),
            condition_id: joi.number(),
        }),
        operator: joi.string().required(),
    })),
    show_ids: joi.bool(),
});
exports.listSchemaJoiSchema = joi.array().items(joi.object().keys({
    column_tag: joi.string().required(),
    column_name: joi.string().required(),
    type: joi
        .string()
        .valid(...Object.values(LIST_ATTRIBUTE_TYPE))
        .required(),
    required: joi.bool(),
    is_unique: joi.bool(),
    options: joi.array().items(joi.object().keys({
        key: joi.string().required(),
        value: joi.any().required(),
        deprecated: joi.boolean().optional(),
    })),
    validation: joi.string(),
    index: joi.number(),
    validation_text: joi.string(),
    is_important: joi.boolean(),
    is_hidden: joi.boolean(),
    locked: joi.boolean(),
    query: joi.string(),
    list_id: joi.string(),
    deprecated: joi.boolean(),
    conditions: workflows_1.conditionsSchema,
}));
const validateList = async (list) => {
    await tools_1.validateJOI(exports.listJoiSchema, list);
    await tools_1.validateJOI(exports.listSchemaJoiSchema, list.schema);
};
exports.validateList = validateList;
